import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { ModulosDeFormulario } from "src/app/utils/formsModules";

@Component({
  selector: 'sub-filtro-status-negocio',
  templateUrl: './status-negocio.component.html',
  styleUrls: ['../../filtro.component.scss'],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatCheckboxModule,
    MatRadioModule,
    MatMenuModule
  ],
})
export class StatusNegocioComponent implements OnInit {
	@Input('listaStatusNegocio') listaStatusNegocio: any = {};
	@Output() atualizaFiltroStatusNegocio = new EventEmitter<{ negocio: any; newValue: boolean }>();


	ngOnInit(): void {
	}
	
}